export const AUTH_TOKEN = '@cookie-auth-token'
export const ACCOUNT_TOKEN = '@cookie-account-token'
